export default {
  title: 'ENABLE MILITARY TIME',
  items: {
    MilitaryTimeConsumerApp: {
      label: 'Consumer App',
      type: 'boolean'
    },
    MilitaryTimeProviderApp: {
      label: 'Provider App',
      type: 'boolean'
    },
    MilitaryTimeBackoffice: {
      label: 'Backoffice',
      type: 'boolean'
    },
    MilitaryTimeWidget: {
      label: 'Booking Widget',
      type: 'boolean'
    },
    MilitaryTimeNotification: {
      label: 'Notifications',
      type: 'boolean'
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/military-time.js